module.exports = __webpack_public_path__ + "img/重庆璧山秀湖国家湿地公园@2x.f4e5bb1b.png";